import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("iframe", {
  src: "https://oceanviking.sosmediterranee.ch/",
  name: "Ocean Viking virtual Tour",
  scrolling: "Yes",
  height: "100%",
  width: "100%",
  style: {"border":"none"}
}, null, -1)
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["virtual-visit-container rounded-xl", { invisible: !_ctx.store.getState().virtualVisitAlreadyOpened, visible: _ctx.store.getState().virtualVisitAlreadyOpened }])
  }, _hoisted_2, 2))
}